import { create } from 'zustand'

interface BUState {
  selectedBuId: number | null
  setSelectedBuId: (id: number) => void
}

const STORAGE_KEY = 'remangu_selected_bu'

function getInitial(): number | null {
  if (typeof window === 'undefined') return null
  const v = localStorage.getItem(STORAGE_KEY)
  return v ? parseInt(v) : null
}

export const useBusinessUnitStore = create<BUState>((set) => ({
  selectedBuId: getInitial(),
  setSelectedBuId: (id) => {
    if (typeof window !== 'undefined') localStorage.setItem(STORAGE_KEY, String(id))
    set({ selectedBuId: id })
  },
}))
